/**
 * @generated SignedSource<<0918d03b3833f855355f221d12c0e844>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HubspotUpdateSettingsInput = {
  associateWithRelatedDeals: boolean;
  autoSendNotesEnabled: boolean;
  clientMutationId?: string | null;
  createHubspotTasksFromActionItems: boolean;
  includeRecapInAutoSendNotes: boolean;
};
export type HubspotIntegrationUpdateSettingsMutation$variables = {
  input: HubspotUpdateSettingsInput;
};
export type HubspotIntegrationUpdateSettingsMutation$data = {
  readonly hubspotUpdateSettings: {
    readonly ok: boolean;
  } | null;
};
export type HubspotIntegrationUpdateSettingsMutation = {
  response: HubspotIntegrationUpdateSettingsMutation$data;
  variables: HubspotIntegrationUpdateSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HubspotUpdateSettingsPayload",
    "kind": "LinkedField",
    "name": "hubspotUpdateSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotIntegrationUpdateSettingsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubspotIntegrationUpdateSettingsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5e24fd4d1873f8449eb129895aa097e2",
    "id": null,
    "metadata": {},
    "name": "HubspotIntegrationUpdateSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation HubspotIntegrationUpdateSettingsMutation(\n  $input: HubspotUpdateSettingsInput!\n) {\n  hubspotUpdateSettings(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "70b399e51a20e830d2add8c645a03c31";

export default node;
